import React from 'react'
import { withTranslation, useTranslation } from 'react-i18next'

import Typography from '../../../components/atoms/display/typography'
import Tooltip from '../../atoms/display/tooltip'

import useStyles from './csatStyle'

const Csat = (props) => {
  const { t } = useTranslation()

  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <Typography className={classes.title}>{props.info}</Typography>
        <div>
          <Tooltip title={props.info}>
            <div>
              <div className={classes.goalContent}>
                <Typography className={classes.goal}>
                  {t('commons.goal')}
                </Typography>
                <Typography className={classes.goal}>{props.goal}</Typography>
              </div>
              <Typography className={classes.value}>{props.value}</Typography>
            </div>
          </Tooltip>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(Csat)
